import React from 'react';

import { getCsrfToken } from '@betterment/js-runtime';
import { Box, Button, Icon } from '@betterment/samba-react';

interface ActivityReportsUrlProps {
  url: string;
}

export const ActivityReportsUrl: React.FC<ActivityReportsUrlProps> = ({ url }) => {
  return (
    <Box css={{ pt: 'space.200' }}>
      <form action={url} method="post" target="_blank" aria-label="View documents">
        <input type="hidden" name="authenticity_token" readOnly={true} value={getCsrfToken() || undefined} />
        <Button variant="textPrimary" css={{ color: 'primitives.blue.60' }} type="submit">
          <Box css={{ display: 'inline-flex', alignItems: 'center', gap: 'space.100' }}>
            <Icon name="DocumentPopulated" size="small" />
            View documents
          </Box>
        </Button>
      </form>
    </Box>
  );
};
